import Buyers from './Buyers';

export default Buyers;
